module.exports = __webpack_public_path__ + "img/thermometer.465ab0af.svg";